/* eslint-disable @next/next/no-img-element */
import Button from "components/general/buttonv2";
import { http } from "src/http";
import { isDev } from "src/lib/config";
import styled from "styled-components";

const StyledWrapper = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  display: ${(props) => (props["data-displayed"] ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 999;
`;
const StyledMask = styled.div`
  height: 100%;
  width: 100%;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: ${(props) => (!props["data-displayed"] ? 0 : 1)};
  pointer-events: ${(props) => !props["data-displayed"] && "none"};
  transition: 0.2s linear;
  left: 0;
  top: 0;
`;
const StyledModal = styled.div`
  padding: 28px 36px;
  display: flex;
  flex-direction: column;
  background-color: var(--text-color);
  text-align: center;
  line-height: 1.5;
  align-items: center;
  position: relative;
  border-radius: 12px;
  width: ${(props) => props["data-width"] || "440px"};
  h2 {
    margin: 18px 0 18px 0;
    font-size: 24px;
  }
  p {
    margin-bottom: 36px;
    font-size: 16px;
  }
`;
const StyledButton = styled(Button)`
  width: 100%;
  display: flex;
  justify-content: center;
`;
const StyledCancel = styled.div`
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 100%;
  color: #bb0000;
  padding: 1rem 2rem;
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  transition: 0.2 linear;
  &:hover {
    background: var(--raised-background-color);
  }
`;

const Modal = ({ displayed, width, hide }) => {
  const handleLogoutClick = async () => {
    const body = {};
    if (process.env.NEXT_PUBLIC_DEV_BRAZIL_REDIRECT_ORIGIN && isDev()) {
      body["redirectOrigin"] = process.env.NEXT_PUBLIC_DEV_BRAZIL_REDIRECT_ORIGIN;
    }
    const res = await http.request({
      method: "post",
      url: "/api/checkout/create-portal-session",
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(body),
    });
    if (res?.data?.data?.portalSessionUrl) {
      window.location.href = res?.data?.data?.portalSessionUrl;
    }
  };
  return (
    <StyledWrapper data-displayed={displayed}>
      <StyledMask data-displayed={displayed} onClick={() => hide()} />
      <StyledModal data-width={width}>
        <img src="/images/crying-redacto.svg" alt="crying redacto" />
        <h2>Are you sure you want to cancel?</h2>
        <StyledButton buttonPrimary={true} onClick={() => hide()} wrapperStyle={{ width: "100%" }}>
          Keep Redact Premium
        </StyledButton>
        <StyledCancel onClick={() => handleLogoutClick()}>Cancel Subscription</StyledCancel>
      </StyledModal>
    </StyledWrapper>
  );
};

export default Modal;
